import styled from 'styled-components';
import { TimePicker } from 'antd';

export const StyledTimePicker = styled(TimePicker)`
    margin-bottom: 0;
    width: 100%;
`;